import React, { type FC } from 'react';

const NavMenu: FC = () => {
    return (
        <div className="w-full flex flex-col pt-8 text-base-content">
            <div className="text-base pb-2">Menu</div>
            <ul className="ml-6">
                <li>
                    <div className="pb-2">
                        <a href="/">Shared Charts</a>
                    </div>
                </li>
                <li>
                    <div className="pb-2">
                        <a href="/reset-password">Reset Password</a>
                    </div>
                </li>
            </ul>
        </div>
    );
};

export default NavMenu;
